import {apiCall} from "./apicall";

export async function login(phone, code) {
    return await apiCall("/auth/admin-login", {"method": "POST"}, {phone, code});
}
